var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329,
    height: 220,
    viewBox: "0 0 329 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M315.56 131.31L265.85 102.6C264.27 101.69 262.21 101.19 260.04 101.19C257.87 101.19 255.81 101.69 254.24 102.61L227.03 118.53C225.23 119.58 224.24 121.05 224.24 122.68C224.24 124.32 225.25 125.8 227.07 126.85L234.68 131.24L220.66 139.48L154.72 101.41C152.23 99.97 148.95 99.18 145.49 99.18C142.03 99.18 138.76 99.97 136.28 101.41L87.46 129.78L73.46 121.55L93.47 109.59C95.27 108.54 96.26 107.07 96.26 105.44C96.26 103.8 95.25 102.32 93.44 101.28L55.11 78.96C53.53 78.05 51.47 77.55 49.3 77.55C47.13 77.55 45.07 78.05 43.49 78.97L2.79 103.3C0.99 104.34 0 105.82 0 107.45C0 109.09 1.01 110.57 2.82 111.61L41.15 133.93C42.73 134.84 44.79 135.34 46.96 135.34C49.13 135.34 51.19 134.84 52.77 133.92L70.75 123.17L84.71 131.38L67.57 141.34C64.86 142.91 63.38 145.09 63.38 147.46C63.38 149.85 64.89 152.03 67.63 153.62L75.99 158.45L61.76 166.82L56.36 163.66C54.79 162.75 52.73 162.25 50.56 162.25C48.39 162.25 46.33 162.75 44.76 163.66L6.44 185.32C4.62 186.37 3.62 187.85 3.61 189.49C3.61 191.12 4.6 192.59 6.39 193.64L21.77 202.64C23.34 203.55 25.4 204.05 27.56 204.05C29.72 204.05 31.79 203.55 33.35 202.64L71.68 180.97C73.5 179.92 74.5 178.44 74.51 176.8C74.51 175.17 73.52 173.7 71.73 172.65L64.5 168.42L78.75 160.04L133.58 191.7L136.34 193.3L144.64 198.09C147.13 199.53 150.41 200.32 153.87 200.32C157.33 200.32 160.6 199.53 163.08 198.09L197.48 178.1L200.24 176.5L231.8 158.16C234.51 156.59 236 154.41 235.99 152.04C235.99 149.65 234.48 147.47 231.74 145.89L223.43 141.09L237.45 132.85L276.79 155.57C278.37 156.48 280.43 156.98 282.6 156.98C284.77 156.98 286.83 156.48 288.4 155.56L315.61 139.64C317.41 138.59 318.4 137.12 318.4 135.49C318.4 133.85 317.39 132.37 315.58 131.32L315.56 131.31ZM51.35 131.53C50.22 132.19 48.61 132.57 46.95 132.57C45.29 132.57 43.68 132.19 42.54 131.53L4.21 109.21C3.3 108.68 2.77 108.04 2.77 107.44C2.77 106.85 3.28 106.22 4.19 105.69L44.89 81.36C46.02 80.7 47.63 80.32 49.29 80.32C50.95 80.32 52.56 80.7 53.7 81.36L92.03 103.69C92.94 104.22 93.46 104.86 93.47 105.45C93.47 106.04 92.96 106.67 92.05 107.2L51.35 131.53ZM70.32 175.05C71.21 175.57 71.73 176.21 71.73 176.79C71.73 177.39 71.21 178.03 70.3 178.55L31.97 200.22C30.83 200.88 29.22 201.26 27.55 201.26C25.88 201.26 24.28 200.88 23.16 200.22L7.78 191.22C6.89 190.7 6.37 190.06 6.37 189.48C6.37 188.88 6.89 188.24 7.8 187.72L46.13 166.05C47.27 165.39 48.88 165.01 50.55 165.01C52.22 165.01 53.82 165.39 54.95 166.05L70.33 175.05H70.32ZM230.34 148.28C232.18 149.35 233.2 150.68 233.2 152.03C233.2 153.37 232.2 154.69 230.39 155.75L161.67 195.68C159.61 196.88 156.84 197.54 153.86 197.54C150.88 197.54 148.1 196.88 146.02 195.68L69 151.21C67.15 150.14 66.14 148.81 66.13 147.46C66.13 146.12 67.13 144.8 68.94 143.74L137.66 103.81C139.72 102.61 142.5 101.95 145.47 101.95C148.44 101.95 151.24 102.61 153.31 103.81L230.33 148.28H230.34ZM314.19 137.22L286.98 153.14C285.85 153.8 284.24 154.18 282.58 154.18C280.92 154.18 279.31 153.8 278.16 153.14L228.45 124.43C227.54 123.9 227.01 123.26 227.01 122.66C227.01 122.07 227.52 121.44 228.42 120.92L255.63 105C256.76 104.34 258.37 103.96 260.03 103.96C261.69 103.96 263.3 104.34 264.45 105L314.16 133.71C315.07 134.24 315.59 134.88 315.59 135.47C315.59 136.06 315.08 136.69 314.18 137.22H314.19Z",
    fill: "url(#paint0_linear_203_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.94 78.04C79.94 78.04 79.98 78.06 80.01 78.07C70.9 72.78 61.8 67.49 52.69 62.2C52.67 62.19 52.65 62.18 52.62 62.17L36.03 54.52C35.38 54.22 34.57 54.36 33.76 54.83C32.95 55.3 32.13 56.1 31.49 57.14L14.99 83.89C14.3 85.01 14.38 86.1 14.94 86.43C15.96 87.02 16.98 87.62 18.01 88.21L18.06 107.13C18.06 108.01 18.37 108.63 18.87 108.92C27.98 114.21 37.08 119.5 46.19 124.8C46.7 125.1 47.4 125.06 48.18 124.61L74.24 109.56C75.78 108.67 77.02 106.52 77.01 104.75L76.95 82.78L78.94 81.63C80.31 80.84 80.96 78.52 79.94 78.04Z",
    fill: "url(#paint1_linear_203_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.13 102.2C41.69 101.79 41.67 100.79 42.31 99.76L58.81 73.01C59.45 71.97 60.26 71.16 61.08 70.69C61.89 70.22 62.71 70.09 63.35 70.38L79.94 78.03C79.94 78.03 79.98 78.05 80.01 78.06C70.9 72.77 61.8 67.48 52.69 62.19C52.67 62.18 52.65 62.17 52.62 62.16L36.03 54.51C35.38 54.21 34.57 54.35 33.76 54.82C32.95 55.29 32.13 56.09 31.49 57.13L14.99 83.88C14.3 85 14.38 86.09 14.94 86.42C15.96 87.01 41.1 101.6 42.13 102.2Z",
    fill: "url(#paint2_linear_203_2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0701 70.69C61.8801 70.22 62.7001 70.09 63.3401 70.38L79.9301 78.03C80.9501 78.5 80.3001 80.82 78.9301 81.62L76.9401 82.77L77.0001 104.74C77.0001 106.51 75.7601 108.66 74.2301 109.55L48.1701 124.6C46.6301 125.49 45.3801 124.77 45.3801 123.01L45.3201 101.04L43.3201 102.19C41.9501 102.98 41.2901 101.41 42.3001 99.77L58.8001 73.02C59.4401 71.98 60.2501 71.17 61.0701 70.7V70.69Z",
    fill: "#E4E7FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.57 91.13C67.15 90.8 67.62 91.06 67.62 91.73L67.65 101.45C67.65 102.11 67.19 102.92 66.61 103.25L57.22 108.67C56.64 109 56.17 108.74 56.17 108.07L56.14 98.35C56.14 97.69 56.6 96.88 57.18 96.54L66.57 91.12V91.13Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M210.71 132.07C210.71 130.81 209.86 129.54 208.2 128.58L153.73 97.13C150.39 95.2 144.99 95.2 141.68 97.13L93.08 125.37C91.42 126.33 90.6 127.6 90.61 128.86C90.61 130.12 90.61 144.72 90.61 145.98C90.61 147.25 91.44 148.53 93.13 149.49L147.6 180.94C150.94 182.87 156.34 182.87 159.66 180.94L208.26 152.7C209.88 151.75 210.71 150.52 210.74 149.28C210.77 147.99 210.74 133.33 210.74 132.07H210.71Z",
    fill: "url(#paint3_linear_203_2)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M206.74 125.87C206.74 125.67 206.65 125.46 206.47 125.35L152 93.91C150.92 93.28 149.35 92.93 147.7 92.93C146.05 92.93 144.49 93.28 143.42 93.9L94.82 122.14C94.66 122.24 94.58 122.44 94.58 122.63C94.58 122.83 94.58 128.64 94.58 128.84C94.58 129.04 94.68 129.25 94.85 129.34L149.32 160.79C150.4 161.42 151.97 161.78 153.63 161.78C155.29 161.78 156.84 161.42 157.91 160.8L206.5 132.56C206.66 132.46 206.74 132.27 206.74 132.07C206.74 131.87 206.74 126.06 206.74 125.87Z",
    fill: "url(#paint4_linear_203_2)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M210.71 105.61C210.71 104.35 209.86 103.08 208.2 102.12L153.73 70.67C150.39 68.74 144.99 68.74 141.68 70.67L93.08 98.91C91.42 99.87 90.6 101.14 90.61 102.4C90.61 103.66 90.61 118.26 90.61 119.51C90.61 120.78 91.44 122.06 93.13 123.03L147.6 154.48C150.94 156.41 156.34 156.41 159.66 154.48L208.26 126.24C209.88 125.29 210.71 124.06 210.74 122.82C210.77 121.53 210.74 106.87 210.74 105.61H210.71Z",
    fill: "url(#paint5_linear_203_2)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M206.74 99.41C206.74 99.21 206.65 99 206.47 98.89L152 67.45C150.92 66.82 149.35 66.47 147.7 66.47C146.05 66.47 144.49 66.83 143.42 67.45L94.82 95.69C94.66 95.79 94.58 95.98 94.58 96.19C94.58 96.39 94.58 102.2 94.58 102.4C94.58 102.6 94.68 102.8 94.85 102.9L149.32 134.35C150.4 134.98 151.97 135.33 153.63 135.33C155.29 135.33 156.84 134.97 157.91 134.35L206.5 106.11C206.66 106.02 206.74 105.82 206.74 105.62C206.74 105.42 206.74 99.61 206.74 99.42V99.41Z",
    fill: "url(#paint6_linear_203_2)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M210.71 79.15C210.71 77.89 209.86 76.62 208.2 75.66L153.73 44.21C150.39 42.28 144.99 42.28 141.68 44.21L93.08 72.45C91.42 73.41 90.6 74.68 90.61 75.94C90.61 77.21 90.61 91.8 90.61 93.05C90.61 94.32 91.44 95.6 93.13 96.57L147.6 128.02C150.94 129.95 156.34 129.95 159.66 128.02L208.26 99.78C209.88 98.84 210.71 97.6 210.74 96.36C210.77 95.07 210.74 80.41 210.74 79.15H210.71Z",
    fill: "url(#paint7_linear_203_2)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.85 75.63L149.32 107.08C150.4 107.7 151.97 108.06 153.63 108.06C155.29 108.06 156.84 107.7 157.91 107.08L206.5 78.84C206.83 78.65 206.82 78.04 206.47 77.84L152 46.39C150.92 45.77 149.35 45.41 147.7 45.41C146.05 45.41 144.49 45.77 143.42 46.39L94.82 74.63C94.49 74.82 94.51 75.43 94.85 75.63Z",
    fill: "url(#paint8_linear_203_2)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.44 109.4C97.6 109.49 97.73 109.72 97.73 109.91V112.66C97.73 112.85 97.6 112.92 97.43 112.83L94.67 111.23C94.5 111.13 94.37 110.91 94.37 110.72V107.97C94.37 107.78 94.51 107.71 94.67 107.8L97.44 109.4Z",
    fill: "url(#paint9_linear_203_2)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M97.44 114.48C97.6 114.57 97.73 114.8 97.73 114.99V117.73C97.73 117.92 97.6 117.99 97.43 117.9L94.67 116.31C94.5 116.22 94.37 115.98 94.37 115.8V113.05C94.37 112.86 94.51 112.79 94.67 112.88L97.44 114.48Z",
    fill: "url(#paint10_linear_203_2)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M102.31 112.3C102.47 112.39 102.6 112.62 102.6 112.81V115.55C102.6 115.74 102.47 115.81 102.3 115.72L99.53 114.12C99.37 114.03 99.24 113.8 99.24 113.61V110.86C99.24 110.67 99.38 110.6 99.54 110.69L102.31 112.29V112.3Z",
    fill: "url(#paint11_linear_203_2)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.31 117.39C102.47 117.48 102.6 117.71 102.6 117.9V120.65C102.6 120.84 102.47 120.91 102.3 120.82L99.53 119.22C99.37 119.13 99.24 118.9 99.24 118.71V115.97C99.24 115.78 99.38 115.71 99.54 115.8L102.31 117.4V117.39Z",
    fill: "url(#paint12_linear_203_2)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107.17 115.21C107.33 115.31 107.46 115.53 107.46 115.72V118.46C107.46 118.65 107.33 118.72 107.16 118.63L104.4 117.03C104.24 116.93 104.11 116.71 104.11 116.52V113.78C104.11 113.59 104.25 113.52 104.41 113.61L107.17 115.2V115.21Z",
    fill: "url(#paint13_linear_203_2)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M107.17 120.29C107.33 120.38 107.46 120.61 107.46 120.8V123.55C107.46 123.74 107.33 123.81 107.16 123.72L104.4 122.12C104.24 122.03 104.11 121.8 104.11 121.61V118.87C104.11 118.68 104.25 118.61 104.41 118.7L107.17 120.29Z",
    fill: "url(#paint14_linear_203_2)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M112.03 118.11C112.19 118.2 112.32 118.43 112.32 118.62V121.37C112.32 121.56 112.19 121.63 112.02 121.54L109.26 119.95C109.09 119.85 108.96 119.63 108.96 119.44V116.69C108.96 116.5 109.1 116.43 109.26 116.52L112.03 118.11Z",
    fill: "url(#paint15_linear_203_2)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M112.03 123.19C112.19 123.28 112.32 123.51 112.32 123.7V126.44C112.32 126.63 112.19 126.7 112.02 126.61L109.26 125.02C109.09 124.92 108.96 124.7 108.96 124.51V121.77C108.96 121.58 109.1 121.51 109.26 121.6L112.03 123.2V123.19Z",
    fill: "url(#paint16_linear_203_2)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M116.96 121.19C117.12 121.28 117.25 121.51 117.25 121.7V124.45C117.25 124.64 117.12 124.71 116.95 124.62L114.19 123.02C114.03 122.92 113.89 122.7 113.89 122.51V119.77C113.89 119.58 114.03 119.5 114.2 119.6L116.97 121.2L116.96 121.19Z",
    fill: "url(#paint17_linear_203_2)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M116.96 126.27C117.12 126.37 117.25 126.59 117.25 126.78V129.53C117.25 129.71 117.12 129.79 116.95 129.7L114.19 128.11C114.03 128.02 113.89 127.79 113.89 127.6V124.85C113.89 124.66 114.03 124.59 114.2 124.68L116.97 126.27H116.96Z",
    fill: "url(#paint18_linear_203_2)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M121.83 124.09C121.99 124.19 122.12 124.41 122.12 124.6V127.34C122.12 127.53 121.98 127.61 121.82 127.51L119.06 125.92C118.9 125.82 118.77 125.6 118.77 125.41V122.66C118.77 122.47 118.91 122.4 119.07 122.49L121.84 124.09H121.83Z",
    fill: "url(#paint19_linear_203_2)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M121.83 129.17C121.99 129.26 122.12 129.49 122.12 129.68V132.42C122.12 132.61 121.98 132.69 121.82 132.59L119.06 131C118.9 130.9 118.77 130.68 118.77 130.49V127.74C118.77 127.55 118.91 127.48 119.07 127.57L121.84 129.17H121.83Z",
    fill: "url(#paint20_linear_203_2)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M97.44 84.67C97.6 84.76 97.73 84.99 97.73 85.18V87.92C97.73 88.11 97.6 88.18 97.43 88.09L94.67 86.49C94.5 86.39 94.37 86.17 94.37 85.98V83.23C94.37 83.04 94.51 82.97 94.67 83.06L97.44 84.66V84.67Z",
    fill: "url(#paint21_linear_203_2)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M97.44 89.7501C97.6 89.8401 97.73 90.0701 97.73 90.2601V93.0101C97.73 93.2001 97.6 93.2701 97.43 93.1801L94.67 91.5801C94.5 91.4901 94.37 91.2601 94.37 91.0701V88.3201C94.37 88.1301 94.51 88.0601 94.67 88.1501L97.44 89.7401V89.7501Z",
    fill: "url(#paint22_linear_203_2)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M102.31 87.57C102.47 87.66 102.6 87.89 102.6 88.08V90.83C102.6 91.02 102.47 91.09 102.3 91L99.53 89.41C99.37 89.31 99.24 89.09 99.24 88.9V86.15C99.24 85.96 99.38 85.89 99.54 85.98L102.31 87.57Z",
    fill: "url(#paint23_linear_203_2)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M102.31 92.66C102.47 92.75 102.6 92.98 102.6 93.17V95.92C102.6 96.11 102.47 96.18 102.3 96.09L99.53 94.5C99.37 94.4 99.24 94.18 99.24 93.99V91.24C99.24 91.05 99.38 90.98 99.54 91.07L102.31 92.67V92.66Z",
    fill: "url(#paint24_linear_203_2)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M107.17 90.48C107.33 90.58 107.46 90.8 107.46 90.99V93.73C107.46 93.92 107.33 93.99 107.16 93.9L104.4 92.3C104.24 92.21 104.11 91.98 104.11 91.79V89.05C104.11 88.86 104.25 88.79 104.41 88.88L107.17 90.47V90.48Z",
    fill: "url(#paint25_linear_203_2)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M107.17 95.5601C107.33 95.6501 107.46 95.8801 107.46 96.0701V98.8201C107.46 99.0001 107.33 99.0801 107.16 98.9901L104.4 97.3901C104.24 97.2901 104.11 97.0701 104.11 96.8801V94.1301C104.11 93.9401 104.25 93.8701 104.41 93.9601L107.17 95.5601Z",
    fill: "url(#paint26_linear_203_2)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M112.03 93.38C112.19 93.47 112.32 93.7 112.32 93.89V96.64C112.32 96.83 112.19 96.9 112.02 96.81L109.26 95.22C109.09 95.12 108.96 94.9 108.96 94.71V91.96C108.96 91.77 109.1 91.7 109.26 91.79L112.03 93.39V93.38Z",
    fill: "url(#paint27_linear_203_2)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M112.03 98.47C112.19 98.56 112.32 98.79 112.32 98.98V101.73C112.32 101.92 112.19 101.99 112.02 101.9L109.26 100.31C109.09 100.21 108.96 99.99 108.96 99.8V97.05C108.96 96.86 109.1 96.79 109.26 96.88L112.03 98.48V98.47Z",
    fill: "url(#paint28_linear_203_2)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M116.96 96.46C117.12 96.55 117.25 96.78 117.25 96.97V99.71C117.25 99.9 117.12 99.97 116.95 99.88L114.19 98.28C114.03 98.19 113.89 97.96 113.89 97.77V95.02C113.89 94.83 114.03 94.76 114.2 94.85L116.97 96.45L116.96 96.46Z",
    fill: "url(#paint29_linear_203_2)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M116.96 101.54C117.12 101.63 117.25 101.86 117.25 102.05V104.79C117.25 104.98 117.12 105.05 116.95 104.96L114.19 103.37C114.03 103.27 113.89 103.05 113.89 102.86V100.11C113.89 99.92 114.03 99.85 114.2 99.94L116.97 101.54H116.96Z",
    fill: "url(#paint30_linear_203_2)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M121.83 99.36C121.99 99.45 122.12 99.68 122.12 99.87V102.61C122.12 102.8 121.98 102.87 121.82 102.78L119.06 101.18C118.9 101.09 118.77 100.86 118.77 100.67V97.93C118.77 97.74 118.91 97.67 119.07 97.76L121.84 99.36H121.83Z",
    fill: "url(#paint31_linear_203_2)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M121.83 104.44C121.99 104.53 122.12 104.76 122.12 104.95V107.7C122.12 107.89 121.98 107.96 121.82 107.87L119.06 106.27C118.9 106.17 118.77 105.95 118.77 105.76V103.01C118.77 102.82 118.91 102.75 119.07 102.84L121.84 104.44H121.83Z",
    fill: "url(#paint32_linear_203_2)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M140.06 106.98C140.58 107.28 141 108.02 140.99 108.62V119.98C140.99 120.58 140.56 120.83 140.04 120.52C139.52 120.22 139.09 119.48 139.09 118.88V107.52C139.09 106.92 139.53 106.67 140.05 106.98H140.06Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M136.5 104.89C137.02 105.19 137.44 105.92 137.44 106.53V117.89C137.44 118.49 137.01 118.74 136.49 118.43C135.97 118.13 135.54 117.39 135.54 116.79V105.43C135.54 104.83 135.98 104.58 136.5 104.89Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M132.95 102.81C133.47 103.11 133.89 103.85 133.89 104.45V115.81C133.89 116.41 133.46 116.66 132.94 116.35C132.42 116.05 131.99 115.31 131.99 114.71V103.35C131.99 102.75 132.43 102.51 132.95 102.81Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M129.39 100.73C129.92 101.03 130.33 101.77 130.33 102.37V113.73C130.33 114.33 129.9 114.57 129.38 114.27C128.86 113.97 128.43 113.23 128.44 112.63V101.27C128.44 100.67 128.88 100.43 129.4 100.73H129.39Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M140.06 133.88C140.58 134.18 141 134.92 140.99 135.52V146.88C140.99 147.48 140.56 147.72 140.04 147.42C139.52 147.12 139.09 146.38 139.09 145.78V134.42C139.09 133.82 139.53 133.58 140.05 133.88H140.06Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M136.5 131.8C137.02 132.1 137.44 132.84 137.44 133.44V144.8C137.44 145.4 137.01 145.65 136.49 145.34C135.97 145.04 135.54 144.3 135.54 143.7V132.34C135.54 131.74 135.98 131.49 136.5 131.8Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M132.95 129.72C133.47 130.02 133.89 130.76 133.89 131.36V142.72C133.89 143.32 133.46 143.57 132.94 143.26C132.42 142.95 131.99 142.22 131.99 141.62V130.26C131.99 129.66 132.43 129.41 132.95 129.72Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M129.39 127.63C129.92 127.93 130.33 128.67 130.33 129.27V140.63C130.33 141.23 129.9 141.48 129.38 141.17C128.86 140.87 128.43 140.13 128.44 139.53V128.17C128.44 127.57 128.88 127.33 129.4 127.63H129.39Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M194.58 91.45C194.06 91.75 193.64 92.49 193.64 93.09V104.45C193.64 105.05 194.07 105.29 194.59 104.99C195.12 104.69 195.54 103.95 195.54 103.35V91.99C195.54 91.39 195.1 91.15 194.58 91.45Z",
    fill: "url(#paint33_linear_203_2)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M198.14 89.36C197.62 89.66 197.21 90.4 197.21 91V102.36C197.21 102.96 197.64 103.2 198.16 102.9C198.68 102.6 199.11 101.86 199.11 101.26V89.9C199.11 89.3 198.67 89.05 198.15 89.35L198.14 89.36Z",
    fill: "url(#paint34_linear_203_2)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M201.69 87.28C201.16 87.58 200.75 88.32 200.75 88.92V100.28C200.75 100.88 201.18 101.13 201.71 100.82C202.23 100.52 202.66 99.78 202.65 99.18V87.82C202.65 87.22 202.21 86.97 201.69 87.28Z",
    fill: "url(#paint35_linear_203_2)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M205.25 85.2C204.73 85.5 204.32 86.24 204.32 86.84V98.2C204.32 98.8 204.75 99.05 205.27 98.74C205.79 98.44 206.22 97.7 206.22 97.1V85.74C206.22 85.14 205.78 84.9 205.26 85.2H205.25Z",
    fill: "url(#paint36_linear_203_2)"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0099 136.91C94.6299 136.69 94.3199 136.16 94.3199 135.72C94.3199 136.16 94.6299 136.69 95.0099 136.91Z",
    fill: "url(#paint37_linear_203_2)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4199 137.29C98.7999 137.51 99.1099 138.04 99.1099 138.48C99.1099 138.92 98.7999 139.1 98.4199 138.87L95.0099 136.91C94.6299 136.69 94.3199 136.16 94.3199 135.72C94.3199 135.28 94.6299 135.11 95.0099 135.33L98.4199 137.29Z",
    fill: "url(#paint38_linear_203_2)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0099 140.36C94.6299 140.14 94.3199 139.61 94.3199 139.17C94.3199 139.61 94.6299 140.14 95.0099 140.36Z",
    fill: "url(#paint39_linear_203_2)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8699 139.3C96.2499 139.52 96.5599 140.05 96.5599 140.49C96.5599 140.93 96.2499 141.1 95.8699 140.88L95.0099 140.35C94.6299 140.13 94.3199 139.6 94.3199 139.16C94.3199 138.73 94.6299 138.55 95.0099 138.77L95.8699 139.3Z",
    fill: "url(#paint40_linear_203_2)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9699 145.02C100.35 145.24 100.66 145.77 100.65 146.21C100.65 146.65 100.34 146.82 99.9599 146.6L94.9999 143.72C94.6199 143.5 94.3099 142.97 94.3099 142.53C94.3099 142.1 94.6199 141.92 94.9999 142.14L99.9599 145.01L99.9699 145.02Z",
    fill: "url(#paint41_linear_203_2)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M103.98 143.99C104.36 144.21 104.67 144.74 104.67 145.18C104.67 145.62 104.36 145.79 103.98 145.58L98.3199 142.32C97.9399 142.1 97.6299 141.57 97.6299 141.13C97.6299 140.69 97.9399 140.52 98.3199 140.74L103.98 144V143.99Z",
    fill: "url(#paint42_linear_203_2)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M103.21 146.94C103.59 147.16 103.9 147.69 103.89 148.13C103.89 148.57 103.58 148.74 103.2 148.53L102.54 148.14C102.16 147.92 101.85 147.39 101.85 146.95C101.85 146.52 102.16 146.34 102.54 146.55L103.21 146.94Z",
    fill: "url(#paint43_linear_203_2)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M101.99 139.37C102.37 139.59 102.68 140.12 102.67 140.56C102.67 141 102.36 141.17 101.98 140.96L101.02 140.4C100.64 140.18 100.33 139.65 100.33 139.21C100.33 138.77 100.64 138.6 101.02 138.82L101.98 139.38L101.99 139.37Z",
    fill: "url(#paint44_linear_203_2)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M106.67 142.09C107.05 142.31 107.36 142.84 107.36 143.28C107.36 143.72 107.05 143.89 106.67 143.67L104.62 142.48C104.24 142.26 103.93 141.73 103.93 141.29C103.93 140.85 104.24 140.68 104.62 140.9L106.66 142.09H106.67Z",
    fill: "url(#paint45_linear_203_2)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M109.69 145.51C109.31 145.29 109 144.76 109 144.32C109 144.76 109.31 145.29 109.69 145.51Z",
    fill: "url(#paint46_linear_203_2)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M113.1 145.88C113.48 146.1 113.79 146.63 113.79 147.07C113.79 147.5 113.48 147.68 113.1 147.46L109.7 145.5C109.32 145.28 109.01 144.75 109.01 144.31C109.01 143.87 109.32 143.7 109.7 143.92L113.11 145.88H113.1Z",
    fill: "url(#paint47_linear_203_2)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M109.69 148.96C109.31 148.74 109 148.21 109 147.77C109 148.21 109.31 148.74 109.69 148.96Z",
    fill: "url(#paint48_linear_203_2)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M110.56 147.9C110.94 148.12 111.25 148.65 111.25 149.09C111.25 149.53 110.94 149.7 110.56 149.48L106.77 147.28C106.39 147.06 106.08 146.53 106.09 146.09C106.09 145.65 106.4 145.48 106.78 145.7L110.57 147.9H110.56Z",
    fill: "url(#paint49_linear_203_2)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M114.65 153.62L109.69 150.75L105.94 148.5C105.56 148.28 105.25 148.46 105.25 148.89C105.25 149.33 105.56 149.86 105.94 150.08L109.7 152.33L114.66 155.2C115.04 155.42 115.35 155.25 115.35 154.81C115.35 154.37 115.05 153.84 114.67 153.62H114.65Z",
    fill: "url(#paint50_linear_203_2)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M121.36 154.13C121.74 154.35 122.05 154.88 122.04 155.32C122.04 155.76 121.73 155.93 121.35 155.71L112.99 150.9C112.61 150.68 112.3 150.15 112.3 149.71C112.3 149.27 112.61 149.1 112.99 149.32L121.35 154.13H121.36Z",
    fill: "url(#paint51_linear_203_2)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M121.36 157.51C121.74 157.73 122.05 158.26 122.04 158.7C122.04 159.14 121.73 159.31 121.35 159.09L120.61 158.68C120.23 158.46 119.92 157.93 119.93 157.49C119.93 157.06 120.24 156.88 120.62 157.1L121.36 157.51Z",
    fill: "url(#paint52_linear_203_2)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M117.89 155.53C118.27 155.75 118.58 156.28 118.58 156.72C118.58 157.15 118.27 157.33 117.89 157.11L117.23 156.72C116.85 156.5 116.54 155.97 116.54 155.53C116.54 155.09 116.85 154.92 117.23 155.14L117.89 155.53Z",
    fill: "url(#paint53_linear_203_2)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M116.67 147.96C117.05 148.18 117.36 148.71 117.35 149.15C117.35 149.59 117.04 149.76 116.66 149.54L115.7 148.98C115.32 148.76 115.01 148.23 115.02 147.79C115.02 147.35 115.33 147.18 115.71 147.4L116.67 147.96Z",
    fill: "url(#paint54_linear_203_2)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M121.36 150.68C121.74 150.9 122.05 151.43 122.04 151.87C122.04 152.31 121.73 152.48 121.35 152.26L119.3 151.07C118.92 150.85 118.61 150.32 118.61 149.88C118.61 149.44 118.92 149.27 119.3 149.49L121.35 150.68H121.36Z",
    fill: "url(#paint55_linear_203_2)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M304.7 130.34L262.61 106.04L241.8 118.05L283.9 142.36L304.7 130.34Z",
    fill: "#F7F7F7"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M283.9 145L241.8 120.69V118.05L283.9 142.35V145Z",
    fill: "#E4E7FB"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M283.9 142.35L304.7 130.34V132.98L283.9 145V142.35Z",
    fill: "url(#paint56_linear_203_2)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M289.14 131.19L285.29 133.41V121.64L289.14 119.42V131.19Z",
    fill: "#E4E7FB"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M328.58 63.61L218.4 0L216.25 1.24L326.43 64.85L328.58 63.61Z",
    fill: "#F7F7F7"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M328.58 144.23V63.61L326.43 64.85V145.48L328.58 144.23Z",
    fill: "url(#paint57_linear_203_2)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M326.43 145.48L216.25 81.87V1.23999L326.43 64.85V145.48Z",
    fill: "#E4E7FB"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M324.37 141.69L218.31 80.46V5.02002L324.37 66.26V141.69Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M323.64 66.65V140.45L219.04 80.07V6.26001L323.64 66.65Z",
    fill: "#EFF1FE"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M285.29 121.72L258.12 106.04V117.81L285.29 133.49V121.72Z",
    fill: "url(#paint58_linear_203_2)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M63.95 159.47L61 157.75C59.61 156.94 57.69 157.06 55.56 158.28C54.79 158.73 54.04 159.29 53.34 159.94L56.29 161.66C56.99 161.01 57.74 160.44 58.51 160C60.63 158.77 62.56 158.66 63.95 159.47Z",
    fill: "url(#paint59_linear_203_2)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5299 158L50.5799 156.28C48.5299 155.09 45.6999 155.26 42.5699 157.06L45.5199 158.78C48.6499 156.97 51.4799 156.81 53.5299 158Z",
    fill: "url(#paint60_linear_203_2)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M45.52 158.79L42.57 157.07C37.63 159.92 33.45 165.99 31.95 171.95L34.9 173.67C36.41 167.71 40.58 161.64 45.52 158.79Z",
    fill: "url(#paint61_linear_203_2)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M20.78 194.35L23.73 196.07C22.89 195.58 22.37 194.55 22.37 193.08C22.37 190.19 24.35 186.68 26.85 185.14L23.9 183.42C21.4 184.96 19.41 188.47 19.42 191.36C19.42 192.83 19.94 193.87 20.78 194.35Z",
    fill: "url(#paint62_linear_203_2)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5199 158.79C40.5799 161.64 36.3999 167.71 34.8999 173.67C34.6999 173.77 34.4899 173.87 34.2899 173.99C30.6499 176.09 27.6199 180.78 26.8599 185.13C24.3599 186.67 22.3699 190.18 22.3799 193.07C22.3799 196.03 24.4799 197.22 27.0599 195.74L58.5699 177.55C62.7899 175.11 66.1999 169.21 66.1799 164.37C66.1699 159.52 62.7399 157.57 58.5199 160.01C57.7499 160.46 56.9999 161.02 56.2999 161.67C54.8599 157.23 50.5699 155.88 45.5199 158.8V158.79Z",
    fill: "url(#paint63_linear_203_2)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8899 173.67L31.9399 171.95C31.7399 172.05 31.5299 172.15 31.3299 172.27C27.6899 174.37 24.6599 179.06 23.8999 183.41L26.8499 185.13C27.5999 180.77 30.6399 176.09 34.2799 173.99C34.4899 173.87 34.6899 173.77 34.8899 173.67Z",
    fill: "url(#paint64_linear_203_2)"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M238.586 177.875C250.813 156.594 250.767 133.618 238.485 126.557C226.202 119.495 206.333 131.023 194.107 152.304C181.88 173.585 181.926 196.561 194.209 203.622C206.491 210.684 226.36 199.156 238.586 177.875Z",
    fill: "#B00238"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M193.212 203.303C193.338 203.386 200.353 207.459 200.353 207.459L198.093 203.711L193.212 203.303Z",
    fill: "#B00238"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M244.862 181.467C257.088 160.186 257.043 137.21 244.76 130.149C232.477 123.087 212.609 134.615 200.382 155.896C188.156 177.177 188.201 200.153 200.484 207.214C212.767 214.276 232.636 202.748 244.862 181.467Z",
    fill: "url(#paint65_linear_203_2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M191.065 187.116C191.014 182.455 191.738 177.808 192.908 173.296C193.509 171.042 194.23 168.821 195.067 166.642C195.9 164.464 196.821 162.316 197.863 160.228C199.928 156.037 202.382 152.049 205.192 148.317C207.986 144.566 211.172 141.123 214.694 138.046C216.462 136.513 218.336 135.106 220.303 133.838C222.268 132.562 224.34 131.458 226.496 130.54C228.655 129.636 230.915 128.934 233.244 128.596L234.119 128.49L234.557 128.439L234.997 128.415L235.879 128.369C236.173 128.364 236.467 128.375 236.761 128.379C237.351 128.371 237.936 128.455 238.523 128.502C238.815 128.534 239.105 128.595 239.396 128.639C239.687 128.681 239.976 128.739 240.262 128.814L241.119 129.028C241.4 129.115 241.679 129.213 241.959 129.305L242.376 129.448L242.783 129.622C243.052 129.742 243.328 129.85 243.591 129.978C244.646 130.503 245.642 131.141 246.559 131.881C246.786 132.065 246.999 132.272 247.22 132.466L247.548 132.762C247.653 132.864 247.75 132.973 247.85 133.079L248.455 133.72L249.009 134.406C249.101 134.52 249.195 134.633 249.284 134.75L249.534 135.111L250.033 135.836L250.479 136.593L250.706 136.971L250.902 137.364C251.961 139.454 252.676 141.703 253.113 143.994C253.55 146.285 253.708 148.624 253.682 150.951C253.648 148.624 253.436 146.298 252.97 144.023C252.504 141.747 251.748 139.532 250.664 137.49L250.464 137.105L250.237 136.734L249.789 135.992L249.291 135.285L249.041 134.931C248.952 134.818 248.859 134.709 248.767 134.597L248.217 133.93L247.617 133.309C247.516 133.206 247.419 133.099 247.315 133L246.991 132.715C246.773 132.527 246.565 132.327 246.339 132.15C245.436 131.438 244.458 130.825 243.423 130.324C243.164 130.2 242.894 130.097 242.631 129.986L242.234 129.82L241.825 129.686C241.552 129.599 241.28 129.506 241.005 129.424L240.167 129.224C239.889 129.155 239.606 129.102 239.321 129.065C239.037 129.024 238.756 128.967 238.47 128.938C237.896 128.9 237.326 128.823 236.75 128.838C236.463 128.838 236.175 128.828 235.888 128.832L235.027 128.882L234.596 128.907L234.168 128.959L233.312 129.065C231.032 129.404 228.814 130.102 226.688 130.999C224.564 131.914 222.522 133.011 220.587 134.278C218.646 135.541 216.796 136.938 215.05 138.461C211.546 141.502 208.375 144.907 205.59 148.619C204.194 150.47 202.867 152.378 201.649 154.352C200.431 156.325 199.291 158.349 198.237 160.417C197.183 162.485 196.242 164.61 195.388 166.769C194.533 168.927 193.792 171.129 193.166 173.365C191.914 177.838 191.138 182.458 191.065 187.116Z",
    fill: "white"
  })))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M237.918 169.472L229.767 164.764L237.918 150.641C239.956 147.109 239.956 143.278 237.918 142.101C235.88 140.923 232.563 142.841 230.525 146.37L222.373 160.494L214.221 155.786C212.179 154.61 208.868 156.525 206.827 160.056C204.787 163.587 204.785 167.419 206.827 168.598L214.979 173.305L206.827 187.427C204.785 190.959 204.785 194.791 206.827 195.968C207.846 196.557 209.185 196.372 210.525 195.599C211.865 194.825 213.203 193.463 214.222 191.698L222.373 177.575L230.524 182.282C231.543 182.871 232.882 182.686 234.221 181.913C235.56 181.139 236.898 179.778 237.918 178.012C239.956 174.48 239.956 170.648 237.918 169.472Z",
    fill: "url(#paint66_linear_203_2)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M210.207 197.902L206.827 195.969L209.059 195.889L210.207 197.902Z",
    fill: "#B7B7B7"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M241.049 171.28L232.898 166.572L241.049 152.45C243.091 148.917 243.091 145.086 241.049 143.909C239.006 142.731 235.694 144.649 233.655 148.178L225.503 162.301L217.352 157.594C215.314 156.418 211.998 158.333 209.958 161.864C207.917 165.395 207.92 169.227 209.958 170.406L218.109 175.113L209.958 189.236C207.92 192.768 207.92 196.599 209.958 197.777C210.977 198.365 212.316 198.18 213.656 197.407C214.996 196.633 216.334 195.271 217.353 193.506L225.504 179.383L233.654 184.091C234.674 184.68 236.012 184.495 237.351 183.721C238.69 182.948 240.03 181.586 241.049 179.82C243.087 176.289 243.087 172.457 241.049 171.28Z",
    fill: "url(#paint67_linear_203_2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M241.048 152.45C241.396 151.811 241.694 151.146 241.939 150.461C242.176 149.775 242.343 149.068 242.439 148.349C242.539 147.634 242.523 146.908 242.393 146.198C242.253 145.498 241.946 144.823 241.436 144.344C240.933 143.85 240.209 143.654 239.515 143.702C238.821 143.75 238.132 144.005 237.515 144.354C236.896 144.715 236.325 145.152 235.816 145.654C235.3 146.155 234.837 146.705 234.431 147.298C234.017 147.882 233.67 148.516 233.305 149.149L232.217 151.041L230.043 154.83C228.593 157.356 227.146 159.884 225.679 162.398L225.576 162.574L225.402 162.473L219.337 158.95L217.824 158.069L217.446 157.849L217.256 157.74L217.072 157.654C217.011 157.626 216.95 157.594 216.887 157.57L216.69 157.516C216.624 157.499 216.56 157.478 216.493 157.463L216.288 157.441C215.741 157.381 215.177 157.486 214.645 157.674C214.113 157.862 213.612 158.157 213.139 158.478C212.201 159.153 211.383 159.98 210.718 160.925C210.039 161.866 209.491 162.895 209.091 163.985C208.705 165.074 208.449 166.23 208.504 167.39C208.523 167.971 208.643 168.543 208.861 169.082C209.079 169.627 209.466 170.088 209.965 170.398C209.452 170.102 209.047 169.649 208.809 169.105C208.573 168.564 208.435 167.986 208.402 167.396C208.318 166.216 208.549 165.038 208.915 163.921C209.297 162.803 209.836 161.745 210.516 160.779C211.186 159.799 212.015 158.937 212.969 158.231C213.455 157.89 213.968 157.575 214.535 157.367C215.103 157.159 215.709 157.031 216.327 157.089L216.558 157.112C216.634 157.127 216.709 157.15 216.785 157.169L217.012 157.23C217.088 157.258 217.155 157.294 217.227 157.326L217.439 157.425L217.631 157.534L218.009 157.752L219.53 158.625L225.612 162.118L225.335 162.194C226.78 159.665 228.245 157.147 229.707 154.626L231.901 150.848L232.998 148.956C233.365 148.333 233.714 147.682 234.155 147.086C234.581 146.482 235.067 145.922 235.605 145.415C236.141 144.902 236.739 144.459 237.385 144.095C238.034 143.739 238.754 143.476 239.51 143.439L239.793 143.429L240.076 143.46C240.266 143.467 240.447 143.535 240.631 143.583C240.722 143.611 240.81 143.648 240.893 143.694C240.981 143.732 241.065 143.775 241.148 143.823L241.38 143.988C241.418 144.016 241.455 144.042 241.495 144.073L241.595 144.173C242.147 144.703 242.443 145.43 242.572 146.155C242.689 146.884 242.687 147.626 242.568 148.354C242.454 149.078 242.268 149.788 242.012 150.473C241.744 151.157 241.422 151.818 241.048 152.45Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_2",
    x1: 0,
    y1: 140.79,
    x2: 318.39,
    y2: 140.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E4E7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EFF1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_203_2",
    x1: 24.88,
    y1: 80.55,
    x2: 56.94,
    y2: 97.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E4E7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EFF1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_203_2",
    x1: 58.89,
    y1: 61.64,
    x2: 51.45,
    y2: 74.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E4E7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EFF1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_203_2",
    x1: 137.89,
    y1: 139.03,
    x2: 171.26,
    y2: 139.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E4E7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EFF1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_203_2",
    x1: 94.58,
    y1: 127.36,
    x2: 206.74,
    y2: 127.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437FEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_203_2",
    x1: 137.89,
    y1: 112.57,
    x2: 171.26,
    y2: 112.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E4E7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EFF1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_203_2",
    x1: -0.0000457764,
    y1: 100.9,
    x2: 0.999954,
    y2: 100.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437FEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_203_2",
    x1: 132.48,
    y1: 86.11,
    x2: 173.09,
    y2: 86.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E4E7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EFF1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_203_2",
    x1: -12.31,
    y1: 76.74,
    x2: 230.35,
    y2: 76.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_203_2",
    x1: 95.06,
    y1: 109.71,
    x2: 123.16,
    y2: 126.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78FFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#71F9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5FEBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#41D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_203_2",
    x1: 92.81,
    y1: 113.43,
    x2: 120.91,
    y2: 130.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_203_2",
    x1: 95.07,
    y1: 109.68,
    x2: 123.17,
    y2: 126.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78FFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#71F9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5FEBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#41D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_203_2",
    x1: 92.82,
    y1: 113.41,
    x2: 120.92,
    y2: 130.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78FFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#71F9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5FEBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#41D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_203_2",
    x1: 95.09,
    y1: 109.66,
    x2: 123.19,
    y2: 126.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_203_2",
    x1: 92.84,
    y1: 113.38,
    x2: 120.94,
    y2: 130.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78FFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#71F9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5FEBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#41D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_203_2",
    x1: 95.11,
    y1: 109.63,
    x2: 123.21,
    y2: 126.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78FFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#71F9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5FEBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#41D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_203_2",
    x1: 92.86,
    y1: 113.35,
    x2: 120.95,
    y2: 130.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_203_2",
    x1: 95.06,
    y1: 109.69,
    x2: 123.17,
    y2: 126.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_203_2",
    x1: 92.81,
    y1: 113.41,
    x2: 120.91,
    y2: 130.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78FFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#71F9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5FEBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#41D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_203_2",
    x1: 95.09,
    y1: 109.67,
    x2: 123.18,
    y2: 126.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_203_2",
    x1: 92.84,
    y1: 113.4,
    x2: 120.93,
    y2: 130.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78FFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#71F9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5FEBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#41D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_203_2",
    x1: 95.06,
    y1: 84.98,
    x2: 123.15,
    y2: 101.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78FFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#71F9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5FEBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#41D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_203_2",
    x1: 92.81,
    y1: 88.7001,
    x2: 120.91,
    y2: 105.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78FFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#71F9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5FEBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#41D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_203_2",
    x1: 95.07,
    y1: 84.96,
    x2: 123.17,
    y2: 101.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_203_2",
    x1: 92.82,
    y1: 88.68,
    x2: 120.92,
    y2: 105.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78FFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#71F9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5FEBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#41D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_203_2",
    x1: 95.09,
    y1: 84.93,
    x2: 123.19,
    y2: 101.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78FFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#71F9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5FEBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#41D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_203_2",
    x1: 92.84,
    y1: 88.6501,
    x2: 120.94,
    y2: 105.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_203_2",
    x1: 95.11,
    y1: 84.9,
    x2: 123.21,
    y2: 101.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_203_2",
    x1: 92.86,
    y1: 88.62,
    x2: 120.96,
    y2: 105.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_203_2",
    x1: 95.06,
    y1: 84.96,
    x2: 123.17,
    y2: 101.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78FFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#71F9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5FEBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#41D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_203_2",
    x1: 92.81,
    y1: 88.68,
    x2: 120.91,
    y2: 105.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78FFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#71F9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5FEBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#41D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_203_2",
    x1: 95.09,
    y1: 84.94,
    x2: 123.18,
    y2: 101.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78FFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#71F9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5FEBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#41D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_203_2",
    x1: 92.84,
    y1: 88.67,
    x2: 120.93,
    y2: 105.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_203_2",
    x1: 195.66,
    y1: 98.22,
    x2: 193.75,
    y2: 98.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_203_2",
    x1: 199.22,
    y1: 96.13,
    x2: 197.19,
    y2: 96.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_203_2",
    x1: 202.77,
    y1: 94.05,
    x2: 200.54,
    y2: 94.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_203_2",
    x1: 206.33,
    y1: 91.97,
    x2: 204.46,
    y2: 91.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_203_2",
    x1: 93.8199,
    y1: 135.48,
    x2: 107.24,
    y2: 149.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437FEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_203_2",
    x1: 94.4999,
    y1: 134.82,
    x2: 107.91,
    y2: 148.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437FEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_203_2",
    x1: 92.4899,
    y1: 137.55,
    x2: 105.9,
    y2: 151.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437FEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_203_2",
    x1: 92.8699,
    y1: 137.18,
    x2: 106.28,
    y2: 150.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437FEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_203_2",
    x1: 92.0399,
    y1: 138.77,
    x2: 105.45,
    y2: 152.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437FEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_203_2",
    x1: 95.2499,
    y1: 137.08,
    x2: 107.63,
    y2: 149.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437FEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_203_2",
    x1: 93.23,
    y1: 137.61,
    x2: 106.64,
    y2: 151.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437FEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_203_2",
    x1: 95.57,
    y1: 133.78,
    x2: 108.98,
    y2: 147.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437FEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_203_2",
    x1: 96.4999,
    y1: 132.87,
    x2: 109.92,
    y2: 146.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437FEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_203_2",
    x1: 108.5,
    y1: 144.07,
    x2: 121.93,
    y2: 157.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_203_2",
    x1: 104.19,
    y1: 138.28,
    x2: 117.61,
    y2: 152.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_203_2",
    x1: 107.16,
    y1: 146.15,
    x2: 120.6,
    y2: 159.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_203_2",
    x1: 103.2,
    y1: 141.97,
    x2: 131.66,
    y2: 171.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_203_2",
    x1: 101.73,
    y1: 143.04,
    x2: 122.79,
    y2: 164.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_203_2",
    x1: 109.13,
    y1: 144.24,
    x2: 122.54,
    y2: 158.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_203_2",
    x1: 108.7,
    y1: 145.44,
    x2: 122.11,
    y2: 159.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_203_2",
    x1: 107.91,
    y1: 146.2,
    x2: 121.33,
    y2: 160.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_203_2",
    x1: 110.25,
    y1: 142.37,
    x2: 123.67,
    y2: 156.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_203_2",
    x1: 111.18,
    y1: 141.46,
    x2: 124.6,
    y2: 155.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_203_2",
    x1: 283.9,
    y1: 137.67,
    x2: 304.7,
    y2: 137.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_203_2",
    x1: 326.43,
    y1: 104.54,
    x2: 328.58,
    y2: 104.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_203_2",
    x1: 258.12,
    y1: 119.77,
    x2: 285.29,
    y2: 119.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E4E7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EFF1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_203_2",
    x1: 53.34,
    y1: 159.45,
    x2: 63.95,
    y2: 159.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E4E7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EFF1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_203_2",
    x1: 42.5599,
    y1: 157.16,
    x2: 53.5299,
    y2: 157.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E4E7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EFF1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_203_2",
    x1: 31.94,
    y1: 165.37,
    x2: 45.52,
    y2: 165.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E4E7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EFF1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_203_2",
    x1: 19.42,
    y1: 189.74,
    x2: 26.85,
    y2: 189.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E4E7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EFF1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_203_2",
    x1: 22.3699,
    y1: 176.81,
    x2: 66.1799,
    y2: 176.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E4E7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EFF1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_203_2",
    x1: 23.8999,
    y1: 178.54,
    x2: 34.8899,
    y2: 178.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E4E7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EFF1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_203_2",
    x1: 199.651,
    y1: 187.208,
    x2: 234.75,
    y2: 130.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E30613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4853"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_203_2",
    x1: 205.298,
    y1: 169.035,
    x2: 239.447,
    y2: 169.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_203_2",
    x1: 208.43,
    y1: 170.843,
    x2: 242.577,
    y2: 170.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 328.58,
    height: 204.04,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.5bb3ed3ad1c5a4ab65dd649394090668.svg";
export { ForwardRef as ReactComponent };